import React from 'react';
import Sync from 'components/Sync';

const SyncPage = () => {
  return <Sync />;
};

export default SyncPage;
